import { Component } from 'react'
import DatePicker, { registerLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
import getNewSpellingForDates from '../../../../functions/getNewSpellingForDates';

registerLocale('de', de);

class AddNewSectionDatePicker extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {form, field, today} = this.props
        const day = getNewSpellingForDates(today)
        const optionObject = {
            expireDay: day
        }
        form.setFieldValue(field.name, optionObject)
    }
    
    componentWillUnmount() {
        const {form, field} = this.props
        const optionObject = {}
 
        form.setFieldValue(field.name, optionObject)
    }

    render() {
        const {startDate, today, handleChange, form, field} = this.props
        return (
            <DatePicker
                selected = {startDate}
                dateFormat="dd/MM/yyyy"
                onChange={(date) => handleChange(date, form, field)}
                todayButton={"Heute"}
                locale="de"
                inline
                showWeekNumbers
                minDate={today}
                placeholderText="Datum wählen"
            />
        )
    }
}

export default AddNewSectionDatePicker
